import { ROUTES } from '@constants'
import { CircularProgress } from '@mui/material'
import { observer } from 'mobx-react-lite'
import { createBrowserRouter, RouterProvider } from 'react-router-dom'

export const OutvoiceRouter = observer(() => {
  const router = createBrowserRouter(ROUTES)

  return (
    <RouterProvider
      router={router}
      fallbackElement={<CircularProgress />}
    />
  )
})
